<template>
  <div class="addBrandComponent">
    <el-dialog title="添加品牌"  width="40%" :visible="isShow">
      <div class="oneline">
        用户名：{{infoObj.name}}
      </div>
      <div class="oneline">
        现有品牌：<span v-if="infoObj.brandArr&&infoObj.brandArr.length==0">暂无</span>
        <br>
        <el-tag type="danger" v-for="(list,index) in infoObj.brandArr" style="margin-right: 10px;">{{list}}</el-tag>
      </div>
      <div>
        <el-input placeholder="请输入内容" v-model="inputValue">
          <template slot="prepend">品牌名称</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close">取 消</el-button>
        <el-button type="primary"  size="mini" @click="submitClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import {
    utils
  } from '@/common/common.js'
  import {
    ajaxPost,
    api
  } from '@/common/request.js'
  export default {
    name: 'addBrand',
    data() {
      return {
        infoObj:{},
        inputValue:'',

      }
    },
    props: ['isShow', 'info'],
    watch: {
      info: {
        handler: function(val, oldVal) {
          this.infoObj=val
        },
        immediate: true
      },
    },
    computed: {
      adminId() {
        return utils.getAdminId()
      },
      IMG_PREV() {
        return api.imgPrev
      },
      api() {
        return api
      },
    },
    methods: {
      close(){
        this.inputValue=""
        this.$emit("close")
      },
      submitClick(){
        let _this=this
        let arg={
          brand: _this.inputValue,
          userId:_this.infoObj.userId
        }
        if(!_this.inputValue){
          _this.$message({
              message: "内容不能为空", //接口返回一个页面
              type: 'error',
              duration: 1000
          });
          return false
        }
        ajaxPost('/commodity/addBrand', arg).then(function(res){
          console.log(res)
          if(res.errorCode==200){
            _this.$message({
                message:"添加成功", //接口返回一个页面
                type: 'success',
                duration: 1500
            });
              _this.inputValue=""
              _this.$emit("closeAndSuccess")
          }else{
            _this.$message({
                message: res.errorMsg, //接口返回一个页面
                type: 'error',
                duration: 1500
            });
          }
        })

      }
    },
    mounted() {}
  }
</script>

<style scoped lang="scss">
  .oneline{padding:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/addBrand.vue